import { render, staticRenderFns } from "./dialog-uploadfiles2.vue?vue&type=template&id=00a90d38&scoped=true&"
import script from "./dialog-uploadfiles2.vue?vue&type=script&lang=js&"
export * from "./dialog-uploadfiles2.vue?vue&type=script&lang=js&"
import style0 from "./dialog-uploadfiles2.vue?vue&type=style&index=0&id=00a90d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a90d38",
  null
  
)

export default component.exports